import { Reveal } from "./Reveal";
import { PORTFOLIO } from "../data/content";

export default function Portfolio() {
    return (
        <section
            id="portofoliu"
            data-testid="portfolio"
            className="px-6 py-32 md:px-12 md:py-48"
            style={{ backgroundColor: "var(--bg-2)" }}
        >
            <div className="mb-20 flex flex-col justify-between gap-8 md:mb-32 md:flex-row md:items-end">
                <Reveal>
                    <span className="eyebrow">Portofoliu</span>
                    <h2
                        className="mt-6 font-serif font-light leading-[0.94]"
                        style={{ fontSize: "clamp(3rem, 7vw, 6.5rem)" }}
                    >
                        Lucrări reale
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <p
                        className="max-w-xs font-sans text-sm leading-relaxed md:text-right"
                        style={{ color: "var(--muted-foreground)" }}
                    >
                        Culori construite în salon, fotografiate fără filtre.
                    </p>
                </Reveal>
            </div>

            {/* Editorial two-column layout with rhythmic offsets */}
            <div className="grid grid-cols-1 gap-x-10 gap-y-20 md:grid-cols-2 md:gap-x-20 md:gap-y-28">
                {PORTFOLIO.map((p, i) => (
                    <div
                        key={i}
                        className={i % 2 === 1 ? "md:mt-40" : ""}
                    >
                        <Reveal y={40}>
                            <figure className="group overflow-hidden">
                                <img
                                    src={p.img}
                                    alt={`Lucrare LadyArt ${i + 1}`}
                                    className="zoomable w-full object-cover"
                                    style={{ aspectRatio: "4 / 5" }}
                                    loading="lazy"
                                />
                            </figure>
                        </Reveal>
                    </div>
                ))}
            </div>
        </section>
    );
}
